import PhotographerOverviewApi from '../PhotographerOverviewApi';
import ICalendar from '../../calendar/ICalendar';
import * as types from './ActionTypes';

function getPhotographerOverviewSuccess(result: any) {
    return { type: types.GET_PHOTOGRAPHER_OVERVIEW_SUCCESS, result };
}

export function getPhotographerOverview(
    year: number,
    month: number,
    day: number,
    streetAddress: string,
    postalCode: string,
    city: string,
    userSite: number
) {
    return function (dispatch: (result: any) => void) {
        return PhotographerOverviewApi.getPhotographerOverview(
            year,
            month,
            day,
            streetAddress,
            postalCode,
            city,
            userSite
        ).then((result: any) => {
            dispatch(getPhotographerOverviewSuccess(result));
        });
    };
}
